import { Box, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useBackFromPaymentTerminal } from "api/api-hooks/use-back-from-terminal";
import PaymentError from "components/error-components/payment-error/payment-error";
import PaymentSpinner from "components/payment-spinner";
import { useError } from "hooks/use-error";
import { PageType } from "logger/page-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { getSearchParams } from "search-params";

const PaymentConfirmation = () => {
    const { validationResult } = useError();
    const backFromTerminal = useBackFromPaymentTerminal();
    const { hasPaymentError } = useError();
    const { chargeId, webBookingId, offerStartTime } = getSearchParams();
    const { system, unitId } = useParams();
    const hasRunMutate = useRef<boolean | null>(null);

    usePageTracking({
        pageName: "PaymentConfirmation",
        pageType: PageType.Page,
        metadata: {
            system,
            unitId,
            hasChargeId: !!chargeId,
            hasBookingId: !!webBookingId,
            hasError: hasPaymentError || (validationResult ? !validationResult.isValid() : false),
        },
    });

    const handleTryPayment = () => {
        backFromTerminal.mutate({
            chargeId: chargeId || "",
            offerStartTime,
        });
    };

    useEffect(() => {
        if (chargeId && webBookingId && !hasRunMutate.current) {
            hasRunMutate.current = true;
            handleTryPayment();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (hasPaymentError || (validationResult && !validationResult.isValid())) {
        return (
            <Box px={ThemeSpaceVariable.Medium}>
                <PaymentError />
            </Box>
        );
    }

    return <PaymentSpinner />;
};

export default PaymentConfirmation;
